
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-buyer",
      function () {
        return require("private-next-pages/home-buyer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-buyer"])
      });
    }
  